export * from './MermaidSpecs/const';
export const MermaidAction = 'createMermaid';
